@import '~swiper/swiper.scss';

:host {
  display: block;
  width: 100%;
  height: fit-content;

  * {
    font-family: var(--ff-manrope !important);
  }
}

.swiper-container.swiper-container-sweep {
  width: 100%;
  height: calc((100vw / 1.2) * 9/16);
  margin: 1rem 0;
  position: relative;

  @media screen and (min-width: 768px) {  
    height: calc((100vw / 1.6) * 9/16);
  }

  @media screen and (min-width: 1024px) {  
    height: calc((100vw / 2) * 9/16);
  }

  .swiper-wrapper.swiper-wrapper-sweep {
    width: 100%;
    height: 100%;

    ::slotted(*){
      width: 100%;
      height: 100%;
    }

  }

  .swiper-pagination.swiper-pagination-sweep {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0rem;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9999;

    span {
      display: block;
      width: 0.4rem;
      height: 0.4rem;
      margin: 0 0.25rem;
      border-radius: 100rem;
      background-color: var(--bullet-nonactive-color);
    }

    span.swiper-pagination-bullet-active {
      background-color: var(--bullet-active-color);
    }
  }

  .sweep-banner-navigation {
    display: none;
    width: 19vw;
    height: 100%;
    font-style: var(--ff-2xl);
    font-weight: 900;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 99;
    cursor: pointer;
    opacity: 1;
    transition: 0.3s linear;

    svg {
      width: 100%;
      height: 100%;
    }

    --gradient-shown: rgba(var(--gradient-R), var(--gradient-G), var(--gradient-B), 1);
    --gradient-hidden: rgba(var(--gradient-R), var(--gradient-G), var(--gradient-B), 0);

    &-prev {
      left: 0;
      background: linear-gradient(90deg, var(--gradient-shown) 0, var(--gradient-hidden) 100%);
    }

    &-next {
      right: 0;
      background: linear-gradient(270deg, var(--gradient-shown) 0, var(--gradient-hidden) 100%);
    }

    &:hover {
      opacity: 0;
    }

    @media screen and (min-width: 768px) {
      display: block;
    }

    @media screen and (min-width: 1024px) {
      width: 25vw;
    }

  }

}

.swiper-sweep-dynamic-content {
  width: 100%;
  max-width: 1024px;
  margin: 2rem auto;
  padding: 0 1rem;
  text-align: center;

  .sweep-banner-hidden-content {
    display: none;
  }
  
  .sweep-banner-active-content {
    display: block;
  }

  .sweep-banner-show-all-content {
    display: block;
    padding: 1rem 0;
    border-bottom: 0.1rem solid var(--show-all-border-color);
  }

  .sweep-banner-show-all-content:last-child {
    border-bottom: unset;
  }

}



